import {SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {checkIfHexBlockedByEnemyUnit} from "../checkIfHexBlockedByEnemyUnit";

/**
 * Проверяет, есть ли в городе (к которому принадлежит указанный квартал) строение Arsenal
 * @param {Object} city - Объект города
 * @param playerId
 * @param units
 * @param hexes
 * @param specialBuildings
 * @param buildingsDamage
 * @returns {boolean} true, если в городе есть arsenal
 */
export const checkIfCityHasWorkingArsenal = (city, playerId, units, hexes, specialBuildings, buildingsDamage) => {
  if (!city) {
    return false;
  }

  // Проверяем, есть ли в городе arsenal
  const arsenalBuildings = city[SPECIAL_BUILDING_TOKENS.ARSENAL] || [];
  const arsenalHexKey = arsenalBuildings[0];
  if (!arsenalHexKey) {
    return false;
  }

  return !checkIfHexBlockedByEnemyUnit(arsenalHexKey, SPECIAL_BUILDING_TOKENS.ARSENAL, playerId, units, hexes, specialBuildings, buildingsDamage);
};
